'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('../../themes/alert.js');
var borders = require('../../themes/borders.js');
require('../../themes/button.js');
require('../../themes/checkbox.js');
require('../../themes/divider.js');
require('../../themes/dropdown.js');
require('../../themes/fieldset.js');
var fonts = require('../../themes/fonts.js');
require('../../themes/input.js');
require('../../themes/list.js');
require('../../themes/listbox.js');
require('../../themes/loader.js');
require('../../themes/option.js');
require('../../themes/popout.js');
require('../../themes/switch.js');
require('../../themes/themes.js');
require('../../themes/tooltip.js');

const baseAlertStyle = styled.css`
  background-color: transparent;
  border-color: transparent;
  border-radius: ${borders.borderRadiusMedium}px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  font-family: ${fonts.fontFamilyBook};
  font-size: 14px;
  line-height: 22px;
  overflow-wrap: anywhere;
  padding: 15px;
`;
/**
 * Get Styled Component alert theme
 * @param options GetAlertThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getAlertTheme = (options)=>{
    const { look  } = options;
    return styled.css`
    background-color: ${({ theme  })=>theme.alert[look].backgroundColor};
    border-color: ${({ theme  })=>theme.alert[look].borderColor};
    color: ${({ theme  })=>theme.alert[look].textColor};

    .bf-alert__icon {
      color: ${({ theme  })=>theme.alert[look].iconColor};
    }

    .bf-button__close {
      background-color: ${({ theme  })=>theme.alert[look].backgroundColor};
      border-color: ${({ theme  })=>theme.alert[look].backgroundColor};
      color: ${({ theme  })=>theme.alert[look].iconColor};

      &:hover {
        color: ${({ theme  })=>theme.alert[look].iconColorHover};
      }

      &:focus-visible {
        color: ${({ theme  })=>theme.alert[look].iconColorHover};
        outline-color: ${({ theme  })=>theme.alert[look].iconColorHover};
      }
    }
  `;
};
/**
 * Get Styled Component inline alert theme
 * @param options GetAlertThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */ const getInlineAlertTheme = (options)=>{
    const { look  } = options;
    return styled.css`
    color: ${({ theme  })=>theme.alert[look].textColorInline};
  `;
};

exports.baseAlertStyle = baseAlertStyle;
exports.getAlertTheme = getAlertTheme;
exports.getInlineAlertTheme = getInlineAlertTheme;
//# sourceMappingURL=alert.js.map
